import type { ReactNode } from "react";

/**
 * Master-detail template (product lock 2026-08-15, lock 2): Inbox, Incidents, Reports
 * drill-in. Pair with `stage: "stage"` in route-templates.ts.
 *
 * Wide, list and detail split the stage 38/62 (widening at 1600px). At 767px and below
 * the list owns the width and the detail pushes over it when `detailOpen`; showing the
 * back affordance and clearing the selection stay with the caller, which is where the
 * selection state already lives.
 *
 * Key the detail contents by the selected id and give the entering node `.mo-detail-enter`
 * for the locked 140ms cross-fade.
 */
export function MasterDetailLayout({
  list,
  detail,
  detailOpen = false,
  className,
}: {
  list: ReactNode;
  detail: ReactNode;
  /** Narrow breakpoints only: pushes the detail pane over the list. */
  detailOpen?: boolean;
  className?: string;
}) {
  const classes = ["mdl"];
  if (detailOpen) {
    classes.push("mdl--detail-open");
  }
  if (className !== undefined) {
    classes.push(className);
  }
  return (
    <div className={classes.join(" ")}>
      <section className="mdl__list">{list}</section>
      <section className="mdl__detail">{detail}</section>
    </div>
  );
}
